export default __webpack_public_path__ + "static/media/info-icon.123cb4b2.svg";